/***********************
 * CALLS TABLE INFO
 ************************/

import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"

import {
  formatDateFull,
  numSorter,
  stringSorter,
  timeFormatter,
} from "utils/general"
//Moment
import moment from "moment"

//Translation
import { withTranslation } from "react-i18next"
import TableReporting from "components/Tables/TableReporting"

const CallsTable = props => {
  //Main title, excel and pdf name
  const [title] = useState(props.t("Calls"))
  //Table data state
  const [series, setSeries] = useState([])
  const [origSeries, setOrigSeries] = useState([])

  //Filtered data
  const [filteredData, setFilteredData] = useState(series)
  const [handleValue, setHandleValue] = useState("")
  const [loading, setLoading] = useState(true)

  //Setting data state
  useEffect(() => {
    // console.log("Data table calls: " + JSON.stringify(props.data.list))
    for (const el of props.data.list) {
      let start = moment(el.date).subtract(el.duration, "seconds")
      el.start_date = start
    }
    setSeries(props.data.list)
    setOrigSeries(props.data.list)
    setLoading(false)
  }, [props.data])

  useEffect(() => {
    if (series != undefined) {
      setFilteredData(series)
      if (handleValue != "") {
        handlingInput(handleValue)
      }
    }
  }, [series])

  // Can be used to modify type
  function typeFormatter(cell) {
    if (cell == "group") {
      return props.t("Group video call")
    } else {
      return props.t(cell)
    }
  }

  // Relative status export
  function statusFormatterExport(cell) {
    return cell == "relative" ? props.t("x") : ""
  }

  // Relative status table
  function statusFormatter(cell) {
    return cell == "relative" ? (
      <i className="dripicons-checkmark text-success "></i>
    ) : (
      <></>
    )
  }

  // Table structure
  const columns = [
    {
      dataIndex: "start_date",
      title: props.t("Start time"),
      width: "140px",
      ellipsis: true,
      render: date => formatDateFull(date),
      sorter: (a, b) => {
        return a.start_date - b.start_date
      },
    },
    {
      dataIndex: "date",
      title: props.t("End time"),
      width: "140px",
      ellipsis: true,
      render: role => formatDateFull(role),
      sorter: (a, b) => {
        return a.date - b.date
      },
    },
    {
      dataIndex: "client_name",
      title: props.t("Customers name"),
      width: "220px",
      ellipsis: true,
      sorter: (a, b) => stringSorter(a, b, "client_name"),
    },
    {
      dataIndex: "group",
      title: props.t("Group"),
      width: "170px",
      ellipsis: true,
      sorter: (a, b) => stringSorter(a, b, "group"),
    },
    {
      dataIndex: "caller",
      title: props.t("Caller"),
      width: "220px",
      ellipsis: true,
      sorter: (a, b) => stringSorter(a, b, "caller"),
    },
    {
      dataIndex: "caller_role",
      title: props.t("Relative"),
      width: "120px",
      ellipsis: true,
      render: role => statusFormatter(role),
      sorter: (a, b) => stringSorter(a, b, "caller_role"),
    },
    {
      dataIndex: "unit_info",
      title: props.t("Unit info"),
      width: "120px",
      ellipsis: true,
      sorter: (a, b) => stringSorter(a, b, "unit_info"),
    },
    {
      dataIndex: "type",
      title: props.t("Type"),
      width: "170px",
      ellipsis: true,
      render: type => typeFormatter(type),
      sorter: (a, b) => stringSorter(a, b, "type"),
    },
    {
      dataIndex: "duration",
      title: props.t("Duration"),
      width: "120px",
      ellipsis: true,
      render: duration => timeFormatter(duration),
      sorter: (a, b) => numSorter(a.duration, b.duration),
    },
  ]

  const pdfHeading = [
    props.t("Start time"),
    props.t("End time"),
    props.t("Customers name"),
    props.t("Group"),
    props.t("Caller"),
    props.t("Relative"),
    props.t("Type"),
    props.t("Unit info"),
    props.t("Duration"),
  ]

  const pdfData = filteredData.map(elt => [
    formatDateFull(elt.start_date),
    formatDateFull(elt.date),
    elt.client_name,
    elt.group,
    elt.caller,
    statusFormatterExport(elt.caller_role),
    elt.unit_info,
    typeFormatter(elt.type),
    timeFormatter(elt.duration),
  ])

  const xlsxHeading = [pdfHeading]

  const xlsxData = filteredData.map(elt => [
    formatDateFull(elt.start_date),
    formatDateFull(elt.date),
    elt.client_name,
    elt.group,
    elt.caller,
    statusFormatterExport(elt.caller_role),
    elt.unit_info,
    typeFormatter(elt.type),
    timeFormatter(elt.duration),
  ])

  // Handle search function
  const handleSearch = event => {
    let value = event.target.value.toLowerCase()
    setHandleValue(value)
    handlingInput(value)
  }

  const handlingInput = value => {
    let result = []
    result = series.filter(
      data =>
        data.client_name?.toLowerCase().includes(value) ||
        data.group?.toLowerCase().includes(value)
    )

    setFilteredData(result)

    // Set original data result if value ""
    if (value == "") {
      setFilteredData(series)
    }
  }

  return (
    <React.Fragment>
      <div>
        <TableReporting
          filter={"calls"}
          origSeries={origSeries}
          setSeries={setSeries}
          title={title}
          columns={columns}
          seriesFiltered={filteredData}
          xlsxHeading={xlsxHeading}
          xlsxData={xlsxData}
          pdfHeading={pdfHeading}
          pdfData={pdfData}
          pdfDate={false}
          handleSearch={handleSearch}
          loading={loading}
        ></TableReporting>
      </div>
    </React.Fragment>
  )
}

CallsTable.propTypes = {
  t: PropTypes.any,
  data: PropTypes.any,
}

export default withTranslation()(CallsTable)
